import owd from 'owd/owd';

export default class ChartLine extends owd.Component {
	init() {
        this.class = '.chart--line'
        this.chart = null;
		this.initChart();
	}

	initChart() {
        this.chart = bb.generate({
            bindto: this.class,
            data: {
                url: this.$element.data('chart-line'),
                x: "x",
                /*
                columns: [
                    ["x", "2010-09-12", "2010-09-13", "2010-09-14", "2010-09-15", "2010-09-16", "2010-09-17", "2010-09-18", "2010-09-19", "2010-09-20", "2010-09-21", "2010-09-22", "2010-09-23", "2010-09-24", "2010-09-25", "2010-09-26", "2010-09-27", "2010-09-28", "2010-09-29", "2010-09-30", "2010-10-01", "2010-10-02", "2010-10-03", "2010-10-04", "2010-10-05", "2010-10-06", "2010-10-07", "2010-10-08", "2010-10-09", "2010-10-10", "2010-10-11", "2010-10-12", "2010-10-13", "2010-10-14", "2010-10-15", "2010-10-16", "2010-10-17", "2010-10-18", "2010-10-19", "2010-10-20", "2010-10-21", "2010-10-22", "2010-10-23", "2010-10-24", "2010-10-25", "2010-10-26", "2010-10-27", "2010-10-28", "2010-10-29", "2010-10-30", "2010-10-31"],
                    ["CPS", 264, 150, 150, 131, 208, 91, 258, 143, 200, 240, 98, 234, 170, 232, 104, 272, 136, 167, 157, 164, 100, 222, 79, 78, 141, 129, 205, 200, 79, 145, 88, 93, 114, 208, 265, 98, 174, 162, 218, 271, 248, 158, 233, 99, 135, 198, 144, 215, 259, 179, 249],
                    ["WIG", 86, 76, 214, 210, 255, 116, 250, 175, 153, 152, 94, 132, 132, 196, 230, 146, 139, 176, 215, 143, 98, 246, 208, 225, 78, 186, 78, 266, 176, 250, 261, 83, 126, 195, 255, 124, 112, 258, 145, 156, 85, 156, 175, 208, 237, 214, 244, 120, 124, 157],
                    ["WIG-MEDIA", 87, 81, 227, 221, 256, 257, 124, 273, 170, 246, 235, 174, 225, 233, 77, 222, 131, 228, 178, 264, 169, 217, 123, 208, 160, 166, 172, 266, 182, 220, 129, 265, 154, 194, 92, 174, 193, 130, 136, 107, 117, 234, 234, 254, 234, 181, 241, 115, 108, 166],
                    ["WIG-TELEKOM", 274, 76, 270, 140, 102, 126, 127, 146, 257, 87, 105, 273, 169, 206, 152, 152, 155, 93, 184, 103, 263, 76, 258, 173, 93, 188, 221, 84, 81, 123, 224, 199, 189, 122, 130, 237, 230, 173, 128, 121, 234, 121, 159, 213, 80, 109, 87, 205, 209, 225]

                    //x,
                    //[dataName].concat(dataValue)
                ],*/
                colors: {
                    CPS: "#F29100",
                    WIG: "#F25C00",
                    "WIG-Media": "#D00212",
                    "WIG-Telekom": "#940404",
                }
//                color: (color, d) => {
//                    return '#F2920A';
//                },
            },

            legend: {
                //hide: true,
                contents: {
                    bindto: '.chart-legend--line',
                    
                    template: (title, color, data) => {
                        return `<li class="legend-item"><span class="chart-legend-color" style="background-color: ${color};"></span><span class="chart-legend-label">${title}</span></li>`;
                    }
                }
                //position: 'bottom'
            },

            axis: {
                x: {
                    tick: {
                        format: (x) => {
                            const monthNames = $('.header').data('lang') === 'pl' ? ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpien", "Wrzesień", "Październik", "Listopad", "Grudzień"] : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                            const month = monthNames[x.getMonth()].substr(0, 3).toLowerCase();
                            const day = x.getDate();
                            
                            return month + ' ' + day;
                        },
                        culling: {
                            max: 13
                        },
                        count: 13,
                        //fit: false,
                    },
                    type: 'timeseries'
                },
                y: {
                    tick: {
                        format: (x) => {
                            return parseInt(x, 10);
                        },
                        count: 5
                    }
                }
            },
            point: {
                show: false  
            },
            
            size: {
                height: 450  
            },
            
            grid: {
                y: {
                    show: true,
                }
            },
            
            tooltip: {
                contents: (d, defaultTitleFormat, defaultValueFormat, color) => {
                    const monthNames = $('.header').data('lang') === 'pl' ? ["Styczeń", "Luty", "Marzec", "Kwiecień", "Maj", "Czerwiec", "Lipiec", "Sierpien", "Wrzesień", "Październik", "Listopad", "Grudzień"] : ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
                    const month = monthNames[d[0].x.getMonth()];
                    const day = d[0].x.getDate();
                    
                    const date = `<div>Data: <span style="font-weight: normal;">${month} ${day}</span>`;
                    let rows = '';
                    
                    d.forEach((item, i) => {
                        rows += `<div>
                                    ${d[i].name}: <span style="font-weight: normal;">${d[i].value}</span>
                                </div>`; 
                    });
                    
                    return `<div>${date}${rows}</div>`;
                }
            },
            
            zoom: {
                //domainValue: [200, 300], 
                //enabled: true
            },
            
            onrendered: () => {
                $(this.class).find('svg').css({
                    height: `${this.chart.internal.currentHeight / 10}rem`
                });
            }
        });
    }

    destroy() {
        this.chart.destroy();
        super.destroy();
    }
}

owd.registerComponent('chart-line', {
	component: ChartLine
});
